document.addEventListener("DOMContentLoaded",()=>{

document
.querySelectorAll(".shop-look-section")
.forEach(section=>{

const spots=
section.querySelectorAll(".shop-hotspot");

const cards=
section.querySelectorAll(".shop-look-card");

const images=
section.querySelectorAll(".shop-look-main-image");

const drawer=
section.querySelector(
".shop-look-mobile-drawer"
);

const body=
section.querySelector(
".drawer-body"
);

const close=
section.querySelector(
".drawer-close"
);

let current=0;

/* ---------- */

function activate(index, openDrawer = true){

spots.forEach(
x=>x.classList.remove("active")
);

images.forEach(
x=>x.classList.remove("active")
);

cards.forEach(
x=>x.classList.remove("active")
);

spots[index]?.classList.add(
"active"
);

images[index]?.classList.add(
"active"
);

cards[index]?.classList.add(
"active"
);

current=index;

/* OPEN ONLY ON HOTSPOT CLICK */

if(
window.innerWidth<=990 &&
drawer &&
openDrawer
){

body.innerHTML="";

body.appendChild(
cards[index].cloneNode(
true
)
);

drawer.classList.add(
"open"
);

}

}

/* ---------- */

spots.forEach(
(spot,index)=>{

spot.addEventListener(
"click",
()=>activate(index)
);

}
);

/* ---------- */

close?.addEventListener(
"click",
()=>{

drawer.classList.remove(
"open"
);

}
);

/* ---------- */

const next=
section.querySelector(
".shop-look-next"
);

const prev=
section.querySelector(
".shop-look-prev"
);

next?.addEventListener(
"click",
()=>{

current++;

if(
current>=cards.length
){
current=0;
}

/* DO NOT OPEN DRAWER */

activate(
current,
false
);

}
);

prev?.addEventListener(
"click",
()=>{

current--;

if(
current<0
){
current=
cards.length-1;
}

/* DO NOT OPEN DRAWER */

activate(
current,
false
);

}
);

activate(
0,
false
);

if(
window.innerWidth<=990
){
drawer?.classList.remove(
"open"
);
}

});

});